import { array } from "./array";
import { arrayOf } from "./array-of";
import { bool } from "./bool";
import { number } from "./number";
import { oneOf } from "./one-of";
import { regex } from "./regex";
import { string } from "./string";

export { array, arrayOf, bool, number, oneOf, regex, string };

export default {
  array,
  arrayOf,
  bool,
  number,
  oneOf,
  regex,
  string
};
